import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=01521169&"
import script from "./TagComponent.vue?vue&type=script&lang=js&"
export * from "./TagComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01521169')) {
      api.createRecord('01521169', component.options)
    } else {
      api.reload('01521169', component.options)
    }
    module.hot.accept("./TagComponent.vue?vue&type=template&id=01521169&", function () {
      api.rerender('01521169', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/components/fields/TagComponent.vue"
export default component.exports